const removeSpaces = (value: string) => {
	if (!value) return '';
	
	const cleanedValue = value.replace(/\s/g, '');
	
	return cleanedValue;
};

export default removeSpaces;
